import csTools from "cornerstone-tools";

const BaseTool = csTools.importInternal("base/BaseTool");

/**
 * @public
 * @class EmptyTool
 * @memberof Tools
 *
 * @classdesc Tool for replacing any active tool.
 * @extends Tools.Base.BaseTool
 */
export class EmptyTool extends BaseTool {
  constructor(props = {}) {
    const defaultProps = {
      name: "EmptyTool",
      supportedInteractionTypes: ["Mouse", "Touch"],
    };

    super(props, defaultProps);
  }
}
